import { BlogHeroSection } from "@shared/components/blog/blog-hero-section";
import { InfoSection } from "@shared/components/blog/info-section";
import { IntroSection } from "@shared/components/blog/intro-section";
import { MainSection } from "@shared/components/blog/main-section";
import { TextWrapper } from "@shared/components/blog/text-wrapper";
import { useLocale } from "@translations/locale-context";
import { StaticImage } from "@ui/components/image/static-image";
import { Trans } from "next-i18next";
import hero from "public/static/landing-pages/4000.png";
import React from "react";

const IntroContenCs = () => (
    <TextWrapper>
        <p>
            Firemní kultura - klíčový aspekt, který si na&nbsp;začátku výběrového řízení nemusí každý uchazeč uvědomovat
            a&nbsp;přitom je často zásadní pro naši spokojenost v&nbsp;životě, kvalitu odvedené práce, dlouhodobé
            fungování, komunikaci a&nbsp;vše kolem. Díky bezpečnému pracovnímu zázemí a&nbsp;pozitivní atmosféře jsme
            schopni eliminovat rizika objevující se&nbsp;frustrace či pocitu vyhoření, které mají za&nbsp;následek
            fluktuaci kvalitních zaměstnanců. Peníze nepřináší vždy 100% štěstí. Tak se&nbsp;na to pojďme podívat
            zblízka. 🔎
        </p>
        <p>
            Pokud rychlým dotazem požádáme chatGPT o&nbsp;rozvržení stráveného času v&nbsp;práci, dostaneme
            se&nbsp;k&nbsp;následujícím číslům:
        </p>
        <ul className="list-disc">
            <li>⅓ našeho života prožijeme v&nbsp;zaměstnání</li>
            <li>cca 2&nbsp;000&nbsp;hodin za&nbsp;rok strávíme tamtéž</li>
            <li>
                za profesní kariéru si celkem odpracujeme cca 90&nbsp;000&nbsp;hodin (počítáme-li období mezi 25.
                a&nbsp;65. rokem života)
            </li>
        </ul>
        <p>
            V&nbsp;rámci zbývající ⅓, věnované volnému času (ta druhá patří spánku,) se&nbsp;snažíme plně věnovat našim
            rodinám, vztahům s&nbsp;blízkými, zábavě a&nbsp;koníčkům. Přitom právě kvalita pracovního prostředí přímo
            ovlivňuje naše chování poté, co zavřeme vchodové dveře firmy a&nbsp;vydáme se&nbsp;vstříc zmiňované ⅓ našeho
            času.
        </p>
        <p>
            Pojďme zabrousit do&nbsp;výzkumných vod. Tak například Chad Hartnell (2019) ověřoval hypotézu, zda-li má
            firemní kultura reálný dopad na&nbsp;efektivitu práce. Z&nbsp;analýzy více jak 140 výzkumů se&nbsp;dostáváme
            k&nbsp;výsledkům, kdy úroveň kultury organizace má obdobně zásadní dopad na&nbsp;efektivitu práce jako
            vedení organizace.{" "}
        </p>
    </TextWrapper>
);

const InfoContentCs = () => (
    <TextWrapper>
        <p>
            A&nbsp;teď trochu z&nbsp;osobního hrníčku. Ve&nbsp;svém životě jsem měla vždy štěstí na&nbsp;organizace,
            které stály na&nbsp;kvalitních a&nbsp;silných základech zaměřených na&nbsp;spolupráci a&nbsp;přátelskou
            atmosféru. Každá z&nbsp;organizací mi dala něco trochu jiného. A&nbsp;jaké pocity mám po&nbsp;roce
            a&nbsp;půl práce v&nbsp;UX Fans s.r.o. ? Popravdě velký vděk a&nbsp;spadlou bradu, jak může fungovat
            pracovní kolektivnost. UX Fans rodina je pro mě nad zlato.
        </p>
        <p>
            Prozatím jsem nezažila tak silné propojení, podporu a&nbsp;týmovost, jak v&nbsp;pracovním, tak osobní
            životě. I&nbsp;přes různorodé povahy jsme schopni dotáhnout společně deadliny projektů, navzájem si pomoci,
            při začínajících obavách z&nbsp;nového a&nbsp;neznámého se&nbsp;podpořit a&nbsp;dodávat sebevědomí, při
            firemních závodech najet desítky kilometrů a&nbsp;zároveň být kolegům celodenní oporou. Jasně, někdy
            se&nbsp;objeví nedorozumění a&nbsp;spory, ale když se&nbsp;hledá řešení, vždy to tým posune dál. Toto je
            za&nbsp;mě kultura, o&nbsp;kterou se&nbsp;musí pečovat. 🫶
        </p>
        <p>
            Když se&nbsp;cítíme podporováni a&nbsp;respektováni, dáváme do&nbsp;práce to nejlepší z&nbsp;nás. To přináší
            jak osobní růst jednotlivým zaměstnancům, tak úspěch celé firmě. V&nbsp;bezpečném zázemí se&nbsp;člověk cítí
            motivován, respektován a&nbsp;díky tomu může s&nbsp;ochotou sdílet své nápady a&nbsp;přispívat
            k&nbsp;dosažení společných cílů.
        </p>
        <p>Všichni jsme na&nbsp;jedné lodi ⛵</p>
        <p>Díky, díky, díky ♡</p>
        <p>Zdroje:</p>
        <p>
            Hartnell, C. A., Ou, A. Y., Kinicki, A. J., Choi, D., & Karam, E. P. (2019). A&nbsp;meta-analytic test
            oforganizationalculture’sassociationwithelementsofanorganization’ssystem and itsrelativepredictive validity
            on organizationaloutcomes. Journalofapplied psychology, 104(6), 832.https://doi.org/10.1037/apl0000380
        </p>
    </TextWrapper>
);

const IntroContentEn = () => (
    <TextWrapper>
        <p>
            Company culture – a key aspect that not every candidate may realize at the start of the recruitment process,
            but it often plays a crucial role in our happiness, work quality, long-term functioning, communication, and
            everything around us. Thanks to a safe work environment and a positive atmosphere, we are able to eliminate
            the risks of emerging frustration or feelings of burnout, which lead to the turnover of quality employees.
            Money doesn&apos;t always bring 100% happiness. So, let&apos;s take a closer look at it. 🔎
        </p>
        <p>If we quickly ask ChatGPT to calculate the time we spend at work, we get the following figures:</p>
        <ul className="list-disc">
            <li>We spend ⅓ of our lives at work</li>
            <li>About 2,000 hours a year at the same place</li>
            <li>Over the course of a career, we work about 90,000 hours (assuming we work between ages 20 and 65)</li>
            <p>
                In the remaining ⅓ dedicated to free time (the other third belongs to sleep), we try to fully devote
                ourselves to our families, relationships with loved ones, fun, and hobbies. Yet, the quality of our work
                environment directly affects our behavior after we close the office doors and step into the remaining
                third of our time.
            </p>
        </ul>
    </TextWrapper>
);

const InfoContentEn = () => (
    <TextWrapper>
        <p>
            Let&apos;s dive into some research. For example, Chad Hartnell (2019) tested the hypothesis of whether
            company culture has a real impact on work efficiency. An analysis of over 140 studies leads to the
            conclusion that the level of organizational culture has a similarly crucial impact on work efficiency as
            organizational leadership.
        </p>
        <p>
            Now, a little personal experience. In my life, I&apos;ve always been fortunate to work in organizations
            built on strong foundations focused on collaboration and a friendly atmosphere. Each organization gave me
            something slightly different. And how do I feel after a year and a half of working at UX Fans s.r.o.?
            Honestly, deep gratitude and amazement at how a workplace can function. The UX Fans family is worth its
            weight in gold to me.
        </p>
        <p>
            So far, I have not experienced such a strong connection, support, and teamwork, both in professional and
            personal life. Despite diverse personalities, we can meet project deadlines together, help each other,
            support and boost confidence when faced with new and unknown challenges, rack up tens of kilometers in
            company races, and be a pillar of support to colleagues all day long. Sure, misunderstandings and conflicts
            sometimes arise, but when we look for solutions, it always moves the team forward. This, to me, is a culture
            that needs to be nurtured. 🫶
        </p>
        <p>
            When we feel supported and respected, we bring the best of ourselves to work. This benefits personal growth
            for individual employees and success for the whole company. In a safe environment, people feel motivated,
            respected, and therefore willingly share their ideas and contribute to achieving shared goals.
        </p>
        <p>We&apos;re all in the same boat ⛵</p>
        <p>Thank you ♡</p>
        <p>
            Sources: Hartnell, C. A., Ou, A. Y., Kinicki, A. J., Choi, D., & Karam, E. P. (2019). A meta-analytic test
            oforganizationalculture’sassociationwithelementsofanorganization’ssystem and itsrelativepredictive validity
            on organizationaloutcomes. Journalofapplied psychology, 104(6), 832.https://doi.org/10.1037/apl0000380
        </p>
    </TextWrapper>
);

export function FiremniKulturaPage() {
    const locale = useLocale();

    return (
        <main>
            <BlogHeroSection
                title={<Trans i18nKey="blog.articles.firemni-kultura.title" components={{ br: <br /> }} />}
                name="Blog"
                author="Zuzana Heferová"
                publishDate="24. 10. 2024"
            >
                <StaticImage
                    alt="Fotografie z hor"
                    src={hero}
                    width={520}
                    height={Math.round(hero.height / (hero.width / 520))}
                    widths={[512, 640, 640, 410, 520, 520]}
                />
            </BlogHeroSection>
            <MainSection>
                <IntroSection>
                    <div>{locale === "en" ? <IntroContentEn /> : <IntroContenCs />}</div>
                </IntroSection>
                <InfoSection noSidebar>
                    <StaticImage
                        alt="Fotografie týmu"
                        src="/static/teambuilding/beerrun23.3.jpg"
                        width={770}
                        height={580}
                    />
                    <div>{locale === "en" ? <InfoContentEn /> : <InfoContentCs />}</div>
                </InfoSection>
            </MainSection>
        </main>
    );
}
